import { Permissions } from '@/types';

const allTrue: Permissions = {
  can_create_users: true,
  can_edit_kanban: true,
  can_config_whatsapp: true,
  can_view_all_leads: true,
  can_assign_leads: true,
  can_view_reports: true,
  can_export_data: true,
  can_delete_leads: true,
  can_import_leads: true,
  can_manage_canned_responses: true
};

export const DEFAULT_PERMISSIONS: Record<string, Permissions> = {
  'super_admin': allTrue,
  'tenant_admin': allTrue,
  'gestor': {
    can_create_users: true,
    can_edit_kanban: true,
    can_config_whatsapp: true,
    can_view_all_leads: true,
    can_assign_leads: true,
    can_view_reports: true,
    can_export_data: false,
    can_delete_leads: false,
    can_import_leads: true,
    can_manage_canned_responses: true
  },
  'vendedor': {
    can_create_users: false,
    can_edit_kanban: false,
    can_config_whatsapp: false,
    can_view_all_leads: false,
    can_assign_leads: false,
    can_view_reports: false,
    can_export_data: false,
    can_delete_leads: false,
    can_import_leads: false,
    can_manage_canned_responses: false
  }
};
